import { Pipe, PipeTransform } from '@angular/core';
import * as Sentry from '@sentry/browser';
import { ELanguage } from 'src/models/common.model';

@Pipe({
  name: 'transactionPrice',
  standalone: false
})
export class TransactionPricePipe implements PipeTransform {
  /**
   * @param value price to transform
   * @param currencyCode BCP 47 language code
   * @param localization APP selected language
   * @returns transformed price
   */
   public transform(value: number, currencyCode: string, localization: ELanguage): string {
    // todo - when price reach some really high value (overflowing div etc) use [notation: "compact"]
    const formatOptions: Intl.NumberFormatOptions = {
      style: 'currency',
      minimumFractionDigits: 0,
      maximumFractionDigits: 2,
      currency: currencyCode
    };

    try {
      return new Intl.NumberFormat(localization, formatOptions).format(value);
    } catch (error) {
      // used to debugg "Value negative out of range for Intl.NumberFormat options property signDisplay" error
      Sentry.addBreadcrumb({ data: { localization } });
      Sentry.addBreadcrumb({ data: { formatOptions } });
      Sentry.addBreadcrumb({ data: { value } });
      Sentry.addBreadcrumb({ data: { error } });
      Sentry.captureException('Debugg message: Failed to parse (2) following number:' + value);
      return value + '';
    }
  }
}
